import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';

import { Container, Segment, Dropdown, Menu, Icon } from 'semantic-ui-react';
import './Header.scss';

const Header = () => {
  const menuItems = [
    {
      key:  'teams',
      text: 'Teams',
      groups: [
        {
          title: 'Herren-Teams',
          items: [
            { id: '002', label: 'Herren I',   to: '/teams/002' },
            { id: '013', label: 'Herren II',  to: '/teams/013' }, 
            { id: '006', label: 'Herren III', to: '/teams/006' },
            { id: '017', label: 'Herren IV',  to: '/teams/017' }
          ]
        },
        {
          title: 'Damen-Teams',
          items: [
            { id: '001', label: 'Damen I'   , to: '/teams/001' },
            { id: '003', label: 'Damen II'  , to: '/teams/003' },
            { id: '008', label: 'Damen III' , to: '/teams/008' },
            { id: '015', label: 'Damen IV'  , to: '/teams/015' }
          ]
        },
        {
          title: 'Freizeit-Teams',
          items: [
            { id: '011', label: 'Gandhis Enkel' , to: '/teams/011' },
            { id: '016', label: 'BSG Waldfrieden' , to: '/teams/016' }
          ]
        },
      ],
    },
    {
      key:  'nachwuchs',
      text: 'Nachwuchs',
      groups: [
        {
          title: 'Jungen-Teams',
          items: [
            { id: 'u12m', label: 'Jungen U12' , to: '/youth/jungen-teams' },
            { id: 'u14m', label: 'Jungen U14' , to: '/youth/jungen-teams' },
            { id: 'u16m', label: 'Jungen U16' , to: '/youth/jungen-teams' },
            { id: 'u18m', label: 'Jungen U18' , to: '/youth/jungen-teams' },
            { id: 'u20m', label: 'Jungen U20' , to: '/youth/jungen-teams' }
          ]
        },
        {
          title: 'Mädchen-Teams',
          items: [
            { id: 'u12w', label: 'Mädchen U12' , to: '/youth/maedchen-teams' },
            { id: 'u14w', label: 'Mädchen U14' , to: '/youth/maedchen-teams' },
            { id: 'u16w', label: 'Mädchen U16' , to: '/youth/maedchen-teams' },
            { id: 'u18w', label: 'Mädchen U18' , to: '/youth/maedchen-teams' }
          ]
        },
        {
          title: 'Kinder',
          items: [
            { id: 'kt001', label: 'Kinderturnen' , to: '/youth/kt001' },
            { id: 'bg001', label: 'Ballspielgruppe' , to: '/youth/bg001' }
          ]
        },
      ],
    },
    {
      key:  'supporters',
      text: 'Förderer',
      groups: [
        {
          title: 'unsere Förderer',
          items: [
            { id: 'sponsoren', label: 'Sponsoren' , to: '/supporters/sponsoren' },
            { id: 'c100', label: 'Club der Hundert' , to: '/supporters/c100' },
            { id: 'spender', label: 'Spender' , to: '/supporters/spender' }
          ]
        },
      ],
    },
    {
      key:  'service',
      text: 'Service',
      groups: [
        {
          title: 'Satzung & Ordnungen',
          items: [
            { id: 'satzung', label: 'Satzung' , to: '/service/regulations/satzung' },
            { id: 'finsnzordnung', label: 'Finazordnung' , to: '/service/regulations/finanzordnung' },
            { id: 'beitragsordnung', label: 'Beitragsordnung' , to: '/service/regulations/beitragsordnung' },
            { id: 'jugendordnung', label: 'Jugendordnung' , to: '/service/regulations/jugendordnung' }
          ]
        },
        {
          title: 'Formulare',
          items: [
            { id: 'aufnahmeantrag', label: 'Aufnahmeantrag' , to: '/service/forms/aufnahmeantrag' }
          ]
        },
      ],
    },
  ];

  return (
    <Segment basic className="header-wrapper" role="banner">
      <Container>
        <div className="header">
          <div className="logo-nav-wrapper">
            <div className="logo">
              <Logo />
	    </div>

            <div id="navigation" className="navigation">
              <div className="desktop-nav">
                {menuItems.map(section => (
                  <Dropdown
                    key={section.key}
                    text={section.text}
                    pointing="top left"
                    className="link item desktop-dropdown"
                    floating
                    labeled
                    icon="dropdown"
                  >
                    <Dropdown.Menu className="multi-column-menu">
		      <div id='flex-container'>
                        {section.groups.map(group => (
                          <div className="box width-5 flex-panel" key={group.title}>
                            <p><strong>{group.title}</strong></p>
                            {group.items.map(item => (
                              <p key={item.id}>
                                <Link to={item.to} className="internal-link">{item.label}</Link>
                              </p>
                            ))}
                          </div>
                        ))}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                ))}
              </div>

	      <div className="mobile-nav">
                <Dropdown
                  className="mobile-hamburger"
                  icon={<Icon name="bars" />}
                  pointing="top right"
                  floating
                >
                  <Dropdown.Menu className="mobile-menu">
                    {menuItems.map(section => (
                      <React.Fragment key={section.key}>
                        <Dropdown.Header content={section.text} />
                        {section.groups.map(group => (
                          <React.Fragment key={group.title}>
                            {group.items.map(item => (
                              <Dropdown.Item as={Link} to={item.to} key={item.id}>
                                {item.label}
                              </Dropdown.Item>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Segment>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};

export default connect((state) => ({
  token: state.userSession.token,
}))(Header);